import React from 'react'
import { Plus } from '~/icons/Plus'

const ButtonLink = ({ text, navType }) => {
  return (
    <span
      className={`main-nav-link ${navType !== 'mainNav' ? 'main-nav-link--profile' : ''}`}
    >
      <span className="main-nav-link__txt">{text}</span>
      <span className="main-nav-link__icon">
        <Plus className="icon-white" width="16" height="16" />
      </span>
    </span>
  )
}

export default ButtonLink
